import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { navItems } from "../mock";
import { useLanguage } from "../contexts/LanguageContext";

const Logo = () => (
  <div
    className="mag-logo"
    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
  >
    <span className="mag-logo-top">MAG</span>
    <span className="mag-logo-bottom">PROTECTION</span>
  </div>
);

const Header = () => {
  const { lang, setLang, t } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (e, href) => {
    e.preventDefault();
    setOpen(false);
    const el = document.querySelector(href);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 70;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <>
      <header className={`mag-header ${scrolled ? "scrolled" : ""}`}>
        <div className="mag-header-inner">
          <Logo />
          <nav className="mag-nav">
            {navItems.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleNav(e, link.href)}
              >
                {t.nav[link.key]}
              </a>
            ))}
          </nav>
          <div className="mag-lang">
            <button
              className={lang === "FR" ? "active" : ""}
              onClick={() => setLang("FR")}
              aria-label="Français"
            >
              FR
            </button>
            <span style={{ color: "#ddd" }}>|</span>
            <button
              className={lang === "EN" ? "active" : ""}
              onClick={() => setLang("EN")}
              aria-label="English"
            >
              EN
            </button>
          </div>
          <button
            className="mag-hamburger"
            onClick={() => setOpen((o) => !o)}
            aria-label="Toggle menu"
          >
            {open ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </header>
      {open && (
        <div className="mag-mobile-menu" style={{ display: "block" }}>
          {navItems.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleNav(e, link.href)}
            >
              {t.nav[link.key]}
            </a>
          ))}
          <div style={{ display: "flex", gap: 12, marginTop: 16 }}>
            <button
              style={{
                border: "none",
                background: lang === "FR" ? "#fde8e8" : "transparent",
                padding: "8px 14px",
                borderRadius: 6,
                fontWeight: 600,
                cursor: "pointer",
                color: lang === "FR" ? "#ea6161" : "#666"
              }}
              onClick={() => setLang("FR")}
            >
              FR
            </button>
            <button
              style={{
                border: "none",
                background: lang === "EN" ? "#fde8e8" : "transparent",
                padding: "8px 14px",
                borderRadius: 6,
                fontWeight: 600,
                cursor: "pointer",
                color: lang === "EN" ? "#ea6161" : "#666"
              }}
              onClick={() => setLang("EN")}
            >
              EN
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
